<template>
  <router-link v-if="showHelper && isCurrentStep" :to="this.step.routerTo.name">
    <div
      class="p-5 rounded shadow-lg text-white flex flex-col md:flex-row items-center justify-center md:justify-between step-helper-container mb-5 bg-purple-ap-100"
    >
      <span class="uppercase text-xl font-bold tracking-wider mr-5"
        >Next Step</span
      >
      <span class="font-thin">{{ step.title }}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "StepsHelper",
  props: ["applicationLevel"],
  computed: {
    step() {
      let step = {};

      switch (this.applicationLevel) {
        case 1:
        default:
          step = {
            title: `View available Au Pairs and pick your favorites`,
            routerTo: {
              name: "/available-au-pairs",
            },
          };
          break;

        case 2:
          step = {
            title: `Compare your favorite Au Pairs and schedule interviews`,
            routerTo: {
              name: "/favorite-au-pairs",
            },
          };
          break;

        case 3:
          step = {
            title: `Complete your interviews and show interest in you preferred Au Pair`,
            routerTo: {
              name: "/request-interview",
            },
          };
          break;

        case 4:
          step = {
            title: `Complete your initial Au Pair request application`,
            routerTo: {
              name: "/your-match-request",
            },
          };
          break;
      }
      return step;
    },
    isCurrentStep() {
      return !this.$route.path.includes(this.step.routerTo.name);
    },
    showHelper() {
      return this.$route.meta.showStepsHelper;
    },
  },
};
</script>

<style></style>
